import { render, staticRenderFns } from "./ComponentUser.vue?vue&type=template&id=2931b6cf&scoped=true"
import script from "./ComponentUser.vue?vue&type=script&lang=js"
export * from "./ComponentUser.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./ComponentUser.vue?vue&type=style&index=1&id=2931b6cf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2931b6cf",
  null
  
)

export default component.exports